import { Link } from "react-router";
import { ArrowRight, Building2, Users, Briefcase } from "lucide-react";

import { TemperaturePill } from "@/components/atomic-crm/shared/TemperaturePill";

import type { CompanyCardPayload } from "./types";

// Sprint 9.3 — Bloc CompanyCard pour Companies D2.
// L'agent émet ce bloc via tool list_companies_by_health ou similaire.

export function CompanyCardBlock({ payload }: { payload: CompanyCardPayload }) {
  return (
    <Link
      to={`/companies/${payload.id}/show`}
      className="block rounded-fabrik-card border border-border bg-card hover:bg-fabrik-green-soft/30 transition-colors px-4 py-3 shadow-card"
    >
      <div className="flex items-start gap-3">
        <div className="size-10 rounded-lg bg-fabrik-gray-pill flex items-center justify-center shrink-0">
          <Building2 className="size-5 text-fabrik-text-2" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="text-[14px] font-semibold text-foreground truncate">
              {payload.name}
            </p>
            {payload.temperature && (
              <TemperaturePill temperature={payload.temperature} />
            )}
          </div>
          <div className="mt-1 flex items-center gap-3 text-[12px] text-fabrik-text-3">
            {payload.sector && <span>{payload.sector}</span>}
            {payload.size && (
              <span className="inline-flex items-center gap-1">
                <Users className="size-3" />
                {payload.size}
              </span>
            )}
            {typeof payload.contacts_count === "number" && (
              <span>
                {payload.contacts_count} contact
                {payload.contacts_count > 1 ? "s" : ""}
              </span>
            )}
            {typeof payload.nb_deals === "number" && (
              <span className="inline-flex items-center gap-1">
                <Briefcase className="size-3" />
                {payload.nb_deals} deal{payload.nb_deals > 1 ? "s" : ""}
              </span>
            )}
          </div>
          {payload.next_action && (
            <p className="mt-1.5 text-[12px] text-fabrik-text-2">
              Prochaine : <strong>{payload.next_action.label}</strong>
              {payload.next_action.date && (
                <span className="text-fabrik-text-3">
                  {" "}
                  · {payload.next_action.date}
                </span>
              )}
            </p>
          )}
        </div>
        {typeof payload.health_score === "number" && (
          <HealthScore score={payload.health_score} />
        )}
        <ArrowRight className="size-4 text-fabrik-text-3 shrink-0 mt-1" />
      </div>
    </Link>
  );
}

function HealthScore({ score }: { score: number }) {
  const color =
    score >= 70
      ? "text-fabrik-green"
      : score >= 40
        ? "text-fabrik-orange"
        : "text-fabrik-red";
  return (
    <div className="text-right shrink-0">
      <div className={`text-[18px] font-bold leading-none ${color}`}>
        {score}
      </div>
      <div className="text-[10px] uppercase tracking-wider text-fabrik-text-3 mt-0.5">
        health
      </div>
    </div>
  );
}
